import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Globle } from 'src/assets/globle';
import { Category } from '../../category/category.model';
import { CategoryService } from '../../category/category.service';
import { ExcelService } from '../../excel.service';
import { SubCategory } from '../../subcategory/subCategory.model';
import { SubcategoryService } from '../../subcategory/subcategory.service';
import { Product } from '../product.model';
import { ProductService } from '../product.service';
import * as FileSaver from 'file-saver';
import * as _moment from 'moment';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { Prices } from '../prices.model';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

import { MatChipInputEvent } from '@angular/material/chips';
import { ProductCardExcelImport } from '../productcardexcel.model';
import { ThemePalette } from '@angular/material/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';



declare var $: any;

@Component({
  selector: 'app-addproduct',
  templateUrl: './addproduct.component.html',
  styleUrls: ['./addproduct.component.css'],
  providers: [
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    // {provide: MAT_DATE_LOCALE, useValue: 'ja-JP'},
    // {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    // {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("ModalConfirmSubmit")

  },
})
export class AddproductComponent implements OnInit {

  //#region variables
  Categories: Category[] = [];
  subCategories: SubCategory[] = [];
  product: Product = {} as Product;
  updateMode = false;
  imagPath: any;
  files = [];
  active = true;
  spinnerOverlay = false;
  filteredOptionsCategory!: Observable<Category[]>;
  filteredOptionsSubCategory!: Observable<SubCategory[]>;
  //searchCategory = new FormControl();
  //searchCategory = new FormControl();
  selectedCategory: any
  ProductForm!: FormGroup;
  _submit = false;
  viewImage = false;
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  productCardDeletedIndex = 0;
  lang: any;
  showSoled: boolean = false;
  userCategory: [] = [];
  prices: Prices[] = [];

  selectable = true;
  removable = true;
  addOnBlur = true;

  color: ThemePalette = 'primary';


  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  //filteredNo!: Observable<string[]>;
  productsListNo: string[] = [];
  productCardsCount: number = 0;
  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;

  pinDigits!: number;
  serialDigits!: number;

  //#endregion
  config = {
    placeholder: 'aaaaa',
    tabsize: 2,
    height: 200,
    dialogsInBody: true,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']
  }
  constructor(private router: Router,
    private service: ProductService,
    private categoryService: CategoryService,
    private subCategoryservice: SubcategoryService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private excelService: ExcelService,
    private dialog: MatDialog,
    private activateRoute: ActivatedRoute,
    private localStorage: LocalStorageService,
    private translate: TranslateService) {
    // this.filteredNo = this.fruitCtrl.valueChanges.pipe(
    //   startWith(null),
    //   map((fruit: string | null) => fruit ? this._filter(fruit) : this.allProductNo.slice()));
  }

  ngOnInit(): void {


    this.connectFormGroup();
    this.imagPath = this.globle.imgPath;
    this.getCategory();
    this.getUrlParam();
    this.lang = this.localStorage.retrieve("lang");
    //  this._adapter.setLocale('en');

    this.ProductForm.get("pinDigits")?.disable()
    this.ProductForm.get("serialDigits")?.disable()
  }

  ngAfterViewInit(): void {
    this.loaddropify();
  }

  connectFormGroup() {

    let _productCards = new FormArray([]);
    let userCategory = new FormArray([]);

    this.product.status = 1;
    this.ProductForm = new FormGroup({

      id: new FormControl(null),
      arabicName: new FormControl(null, [
        Validators.required
      ]),
      englishName: new FormControl(null, [
        Validators.required
      ]),
      // userCtegoryPrice:userCategory,
      price1: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price2: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price3: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price4: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      price5: new FormControl(null, [
        Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      newCardsCostPrice: new FormControl(null, [
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      originalProductCostPrice: new FormControl(null, [
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),

      purchaseLimit: new FormControl(0, [
        // Validators.required,
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ]),
      subCategoryId: new FormControl(null, [

      ]),
      category: new FormControl(null, [
        Validators.required
      ]),
      subCategory: new FormControl(null, [
        Validators.required
      ]),
      status: new FormControl(this.product.status),
      statusBool: new FormControl(),
      imageUrl: new FormControl(''),
      direct: new FormControl(false),
      cardsHowToUse: new FormControl(''),
      productCards: _productCards!,
      cardNumbers: new FormControl(''),
      productLock: new FormControl(this.product.productLock),
      pinDigits: new FormControl(14),
      serialDigits: new FormControl(9),
      serialPinCount: new FormControl(false)
    });

    this.addProductCardRow();
    // this.getUserCategory();
  }

  getProductCardControls() {
    return (<FormArray>this.ProductForm.get('productCards')).controls;
  }

  getNewCardsCostPrice(): number | null {
    const value = this.ProductForm?.get('newCardsCostPrice')?.value;
    return value === null || value === '' || value === undefined ? null : Number(value);
  }

  getOriginalProductCostPrice(): number | null {
    const value = this.ProductForm?.get('originalProductCostPrice')?.value;
    if (value !== null && value !== '' && value !== undefined && Number(value) > 0) {
      return Number(value);
    }
    return null;
  }

  /** Cost used for new cards: cost price field, else original product cost. */
  getCostPriceForNewCards(): number | null {
    const costPrice = this.getNewCardsCostPrice();
    if (costPrice !== null && costPrice > 0) {
      return costPrice;
    }
    return this.getOriginalProductCostPrice();
  }

  onCostPriceInput() {
    const costPrice = this.getNewCardsCostPrice();
    if (costPrice !== null && costPrice > 0) {
      this.ProductForm.get('originalProductCostPrice')?.setValue(costPrice);
    }
  }

  /** Read a numeric cost from API payload (supports camelCase / PascalCase). */
  readApiCost(data: any): number {
    const candidates = [
      data?.originalProductCostPrice,
      data?.OriginalProductCostPrice,
      data?.costPrice,
      data?.CostPrice
    ];
    for (const value of candidates) {
      if (value !== null && value !== undefined && value !== '' && Number(value) > 0) {
        return Number(value);
      }
    }
    return 0;
  }

  /**
   * Fill original + cost price fields after get-by-id.
   * Order: API original/cost → last loaded card cost.
   */
  applyProductCostFromApi(data: any) {
    let cost = this.readApiCost(data);

    if (cost <= 0) {
      const cards = data?.lstProductCards || data?.LstProductCards || [];
      for (let i = cards.length - 1; i >= 0; i--) {
        const cardCost = cards[i]?.costPrice ?? cards[i]?.CostPrice;
        if (cardCost !== null && cardCost !== undefined && cardCost !== '' && Number(cardCost) > 0) {
          cost = Number(cardCost);
          break;
        }
      }
    }

    this.ProductForm.get('originalProductCostPrice')?.setValue(cost > 0 ? cost : 0);
    this.ProductForm.get('newCardsCostPrice')?.setValue(cost > 0 ? cost : null);
  }

  /**
   * If original cost is 0/empty, fill it from the last product card that has a cost price.
   * Also seed the cost price field from that value for new cards.
   */
  fillOriginalCostFromLastCard(cards: any[]) {
    this.applyProductCostFromApi({
      originalProductCostPrice: this.getOriginalProductCostPrice(),
      lstProductCards: cards
    });
  }

  resolveCardCostPrice(values?: any): number | null {
    const cardCost = values?.costPrice;
    if (cardCost !== null && cardCost !== undefined && cardCost !== '' && Number(cardCost) > 0) {
      return Number(cardCost);
    }
    return this.getCostPriceForNewCards();
  }

  createProductCardFormGroup(values?: any): FormGroup {
    const costPrice = this.resolveCardCostPrice(values);
    return new FormGroup({
      id: new FormControl(values?.id ?? ''),
      cardNumber: new FormControl(values?.cardNumber ?? '', [Validators.required, Validators.pattern(/^\S*$/)]),
      serialNumber: new FormControl(values?.serialNumber ?? ''),
      expiryDate: new FormControl(values?.expiryDate ?? ''),
      status: new FormControl(values?.status ?? 0),
      addedBy: new FormControl(values?.addedBy ?? this.localStorage.retrieve('userInfo').userId),
      costPrice: new FormControl(costPrice, [
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,5})?$')
      ])
    });
  }

  applyBatchCostPriceToNewCards() {
    const costForNewCards = this.getCostPriceForNewCards();

    this.getProductCardControls().forEach(control => {
      if (!control.get('id')?.value) {
        const current = control.get('costPrice')?.value;
        if (current === null || current === '' || current === undefined || Number(current) <= 0) {
          if (costForNewCards !== null) {
            control.get('costPrice')?.setValue(costForNewCards);
          }
        }
      }
    });
    return true;
  }

  validateNewCardsCostPrice(): boolean {
    // Cost price is optional; empty/0 falls back to original product cost on save.
    this.onCostPriceInput();
    this.applyBatchCostPriceToNewCards();
    return true;
  }

  addProductCardRow() {
    (<FormArray>this.ProductForm.get('productCards')).push(this.createProductCardFormGroup());
  }

  // addPriceRow() {
  //   (<FormArray>this.ProductForm.get('userCtegoryPrice')).push(
  //     new FormGroup({
  //       id: new FormControl(""),
  //       name: new FormControl(""),
  //       price:new FormControl(0)
  //     }))
  // }

  // getUserCategoryPriceControls() {
  //   return (<FormArray>this.ProductForm.get('userCtegoryPrice')).controls;
  // }


  // initUserPriceRow(data:any){
  //   for (let i = 0; i < data.length; i++) {
  //     (<FormArray>this.ProductForm.get('userCtegoryPrice')).push(
  //       new FormGroup({
  //         id: new FormControl(data[i]["id"]),
  //      name :new FormControl(data[i]["name"]),
  //      price:new FormControl(0)
  //       }));
  //   }
  // }

  deleteProductCardRow(index: number) {

    const control = (<FormArray>this.ProductForm.get('productCards'));
    let id = this.getProductCardControls()[index].get("id")?.value;
    if (!this.updateMode || (this.updateMode && id == '')) {
      if (control.length != 1)
        control.removeAt(index);
    }
    else {
      this.productCardDeletedIndex = index;
      this.openDialog()
    }

  }

  getCategory() {
    this.categoryService.getAll(1).subscribe(data => {
      this.Categories = data

      this.autoCompleatFilterCategory();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  getSubCategory() {
    this.subCategoryservice.getAll(this.selectedCategory, 1, this.ProductForm.value.direct).subscribe(data => {
      this.subCategories = data;
      this.autoCompleatFilterSubCategory();
      this.spinnerOverlay = false;
    })
  }

  // getUserCategory() {
  //   this.service.getUserCategory().subscribe(data => {
  //     this.userCategory = data;
  //     this.initUserPriceRow(this.userCategory);
  //   })
  // }

  autoCompleatFilterCategory() {
    this.filteredOptionsCategory = this.ProductForm.get("category")!.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value != null ? value.name : ''),
        map(name => name ? this._filterCategory(name) : this.Categories.slice())
      );
  }

  autoCompleatFilterSubCategory() {
    this.filteredOptionsSubCategory = this.ProductForm.get("subCategory")!.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value != null ? value.name : ''),
        map(name => name ? this._filterSubCategory(name) : this.subCategories.slice())
      );
  }

  _filterCategory(name: string): Category[] {
    const filterValue = name.toLowerCase();
    return this.Categories.filter(option => option.arabicName.toLowerCase().indexOf(filterValue) === 0);
  }

  _filterSubCategory(name: string): SubCategory[] {
    const filterValue = name.toLowerCase();
    return this.subCategories.filter(option => option.arabicName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFnCategory(category: Category): string {
    return category && category.arabicName ? category.arabicName : '';
  }

  displayFnSubCategory(subCategory: SubCategory): string {
    return subCategory && subCategory.arabicName ? subCategory.arabicName : '';
  }

  loaddropify() {
    var drEvent = $('.dropify').dropify();

    drEvent.on('dropify.afterClear', () => {
      //this.product.imgUrl = null
    });

  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.product.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  disableControlsOnUpdate() {
    this.ProductForm.get("category")?.disable();
    this.ProductForm.get("subCategory")?.disable();
    this.ProductForm.get("direct")?.disable();
    this.getProductCardControls().forEach(control => { control.disable() });
  }

  getById() {
    this.spinnerOverlay = true;
    this.service.getById(this.product.id).subscribe(data => {
      this.product = data
      this.fillControl(data);
      this.spinnerOverlay = false;
      if (data["imageUrl"] != null && data["imageUrl"]) {
        this.fillDropifyImage(this.imagPath + data["imageUrl"]);
        this.viewImage = false;
        //$('#dropifyImage').show();
      }
    }, error => {
      this.spinnerOverlay = false;
    })
  }

  fillControl(data: any) {
    if (!data) {
      return;
    }

    const subCategory = data["subCategory"] || data["SubCategory"];
    const category = subCategory ? (subCategory["category"] || subCategory["Category"]) : null;
    if (category) {
      this.ProductForm.get("category")!.setValue(category);
    }

    this.ProductForm.get("statusBool")!.setValue((data["status"] ?? data["Status"]) ? true : false);

    this.prices = data["lstUserCategoryProduct"] || data["LstUserCategoryProduct"] || [];
    let price1 = this.prices.find(x => x.userCategoryId == 1)?.price;
    let price2 = this.prices.find(x => x.userCategoryId == 2)?.price;
    let price3 = this.prices.find(x => x.userCategoryId == 3)?.price;
    let price4 = this.prices.find(x => x.userCategoryId == 4)?.price;
    let price5 = this.prices.find(x => x.userCategoryId == 5)?.price;

    this.ProductForm.get("price1")!.setValue(price1);
    this.ProductForm.get("price2")!.setValue(price2);
    this.ProductForm.get("price3")!.setValue(price3);
    this.ProductForm.get("price4")!.setValue(price4);
    this.ProductForm.get("price5")!.setValue(price5);

    this.selectedCategory = category ? (category['id'] ?? category['Id']) : null;
    if (this.selectedCategory) {
      this.getSubCategory();
    }

    this.ProductForm.patchValue(data);

    (<FormArray>this.ProductForm.get('productCards')).removeAt(0);
    for (let i = 0; i < (data["lstProductCards"] || []).length; i++) {

      (<FormArray>this.ProductForm.get('productCards')).push(
        this.createProductCardFormGroup({
          id: data["lstProductCards"][i]["id"],
          cardNumber: data["lstProductCards"][i]["cardNumber"],
          serialNumber: data["lstProductCards"][i]["serialNumber"],
          expiryDate: data["lstProductCards"][i]["expiryDate"],
          status: data["lstProductCards"][i]["status"],
          addedBy: data["lstProductCards"][i]["addedBy"],
          costPrice: data["lstProductCards"][i]["costPrice"] ?? data["lstProductCards"][i]["CostPrice"]
        }));
    }

    // Apply cost AFTER patchValue so it is not overwritten / missed by casing.
    this.applyProductCostFromApi(data);
    // Re-apply on next tick in case any async autocomplete/subcategory work clears the control.
    setTimeout(() => this.applyProductCostFromApi(data), 0);

    this.encodeDecodeCardNo(false);

    this.disableControlsOnUpdate();
    this.addProductCardRow();

    // if (this.ProductForm.value.direct) {
    //   for (let i = 0; i < this.getProductCardControls().length; i++) {
    //     const control = (<FormArray>this.ProductForm.get('productCards'));
    //     control.removeAt(i);
    //   }
    // }

  }

  back() {
    this.router.navigate(["./master/cards/products"]);
  }

  encodeDecodeCardNo(encode: boolean) {
    var decoder = new TextDecoder();
    encode ?
      this.getProductCardControls().forEach(control => {
        // control.get("cardNumber")?.setValue(btoa(control.get("cardNumber")?.value))
        control.get("cardNumber")?.setValue(Buffer.from(btoa(control.get("cardNumber")?.value), 'utf-8').toString())
      }) :

      this.getProductCardControls().forEach(control => {
        control.get("cardNumber")?.setValue(atob(control.get("cardNumber")?.value))
        // control.get("cardNumber")?.setValue(atob(Buffer.from(control.get("cardNumber")?.value, 'utf-8').toString()))
      })

  }

  submit() {
    //this.encodeDecodeCardNo(true);

    this.ProductForm.get("subCategoryId")!.setValue(this.ProductForm.get("subCategory")!.value['id']);
    this.ProductForm.get("cardsHowToUse")?.setValue(this.product.cardsHowToUse);

    if (!this.validateNewCardsCostPrice()) {
      return;
    }

    if (this.files.length > 0) {
      this.uploadImage();
    }
    else {
      !this.updateMode ? this.create() : this.update();
    }
  }

  private normalizeProductFormValue(formValue: any) {
    formValue.purchaseLimit = Number(formValue.purchaseLimit) || 0;
    return formValue;
  }

  create() {
    const formValue = this.normalizeProductFormValue({ ...this.ProductForm.getRawValue() });
    this.onCostPriceInput();
    const costPrice = this.getCostPriceForNewCards() ?? 0;
    const originalCost = this.getOriginalProductCostPrice() ?? costPrice;
    formValue.originalProductCostPrice = originalCost;
    formValue.costPrice = costPrice;
    formValue.newCardsCostPrice = costPrice;

    this.service.Create(formValue).subscribe(data => {
      this.spinnerOverlay = false;
      this._submit = true;
      //this.encodeDecodeCardNo(false);
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        //this.encodeDecodeCardNo(false);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  update() {
    if (!this.validateNewCardsCostPrice()) {
      return;
    }

    this.productCardsCount = 0;
    this.ProductForm.get("status")!.setValue(this.ProductForm.value.statusBool ? 1 : 0)

    let productCard = this.ProductForm.value.productCards;

    for (let i = 0; i < productCard.length; i++) {
      if (productCard[i].cardNumber == "") {
        productCard.splice(i, 1);
      }
    }
    this.productCardsCount = productCard.length;
    if (this.productCardsCount > 0) {
      this.openDialogConfirmInput()
    }

    else {
      this.confirmUpdate();
    }
  }

  checkIfDuplicateExists(arr: any) {
    return new Set(arr).size !== arr.length
  }

  confirmUpdate() {
    this.dialog.closeAll();
    this.spinnerOverlay = true;
    this.onCostPriceInput();
    this.applyBatchCostPriceToNewCards();
    this.ProductForm.get("status")!.setValue(this.ProductForm.value.statusBool ? 1 : 0)

    // getRawValue includes disabled controls (needed on edit).
    const formValue = this.normalizeProductFormValue({ ...this.ProductForm.getRawValue() });
    // Only send NEW cards (existing rows are disabled and must not be re-created).
    formValue.productCards = (formValue.productCards || []).filter((c: any) => c.cardNumber && !c.id);

    const costPrice = this.getNewCardsCostPrice() ?? 0;
    let originalCost = this.getOriginalProductCostPrice() ?? 0;
    // If user typed cost price, keep original in sync with it.
    if (costPrice > 0) {
      originalCost = costPrice;
      this.ProductForm.get('originalProductCostPrice')?.setValue(costPrice);
    }
    formValue.originalProductCostPrice = originalCost;
    formValue.costPrice = costPrice > 0 ? costPrice : originalCost;

    this.service.Update(formValue).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.ProductForm.reset();
      this.back();
      // this.getById();
      //this.encodeDecodeCardNo(false);
    },
      error => {
        console.log(error);
        //this.encodeDecodeCardNo(false);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
        this.spinnerOverlay = false;
      })
  }

  onSelectImage(event: any) {
    this.files = event.target.files;
  }

  uploadImage() {

    this.spinnerOverlay = true;
    let fileToUpload = <File>this.files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.service.uploadImage(formData).subscribe(data => {

      this.ProductForm.get("imageUrl")!.setValue(data['dbPath']);

      !this.updateMode ? this.create() : this.update();
    }, error => {
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
      this.spinnerOverlay = false;
    });
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  fillDropifyImage(imgUrl: any) {
    var drEvent = $('.dropify').dropify(
      {
        defaultFile: imgUrl
      });
    drEvent = drEvent.data('dropify');
    drEvent.resetPreview();
    //drEvent.clearElement();
    drEvent.settings.defaultFile = imgUrl;
    drEvent.destroy();
    drEvent.init();
  }

  selectCatChange(value: any) {
    this.spinnerOverlay = true;
    this.selectedCategory = value.id;
    this.getSubCategory();
  }

  addNew() {

    this.ProductForm.reset();
    this.subCategories = [];
    //this.sizelist = [];
    //this.filteredOptionsSubCategory = null;
    $('#dropifyImage').hide();
    this.viewImage = false;
    for (let i = 0; i < this.getProductCardControls().length; i++) {
      this.deleteProductCardRow(i);
    }
    this.fillDropifyImage(null);
    this._submit = false;
  }

  viewDropify() {
    this.viewImage = !this.viewImage;
    !this.viewImage ? $('#dropifyImage').hide() : $('#dropifyImage').show();

  }

  Import() {
    $('#file-input').trigger('click');
  }

  importCards(event: any) {

    this.applyBatchCostPriceToNewCards();

    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {

      const bstr: string = e.target.result;

      const data = <string[]>this.excelService.importFromFile(bstr);
      console.log(data)
      if (!this.updateMode) {
        for (let i = 0; i < (<FormArray>this.ProductForm.get('productCards')).length; i++) {
          (<FormArray>this.ProductForm.get('productCards')).removeAt(i);
        }
      }

      for (let i = 1; i < data.length; i++) {
        (<FormArray>this.ProductForm.get('productCards')).push(
          this.createProductCardFormGroup({
            cardNumber: data[i][0],
            serialNumber: data[i][1],
            expiryDate: new Date(data[i][2])
          }))
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogConfirmInput(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '300px',
    });
  }

  deleteProductCard(index: number) {

    let id = this.getProductCardControls()[index].get("id")?.value;
    this.dialog.closeAll();
    this.service.deleteProductCard(id, this.product.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');

      const control = (<FormArray>this.ProductForm.get('productCards'));
      control.removeAt(index);

      if (this.getProductCardControls().length == 0) {
        this.addProductCardRow();
      }
    },
      error => {
        console.log(error);
        this.openSnackBar("Internal server error", 'snackBarError');
      })
  }

  confirmDelete() {
    this.deleteProductCard(this.productCardDeletedIndex);
  }

  onShowSoled() {
    this.showSoled = !this.showSoled
  }

  downloadTemp() {
    FileSaver.saveAs("../../../assets/CardList.xlsx");
  }

  onDirectChargedChanged() {
    this.spinnerOverlay = true;
    // this.ProductForm.get("category")!.setValue("");
    this.ProductForm.get("subCategory")!.setValue("");

    if (this.ProductForm.value.direct) {
      for (let i = 0; i < this.getProductCardControls().length; i++) {
        const control = (<FormArray>this.ProductForm.get('productCards'));
        control.removeAt(i);
      }
    }
    else {
      this.addProductCardRow();
    }

    this.getSubCategory();
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    let value2 = event.value.split(' ');


    for (let i = 0; i < value2.length; i++) {
      if (value2[i]) {
        this.productsListNo.push(value2[i]);
      }

    }
    // Add our fruit
    // if (value) {
    //   this.fruits.push(value);
    // }

    // Clear the input value
    event.input.value = "";

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    console.log(fruit)
    const index = this.productsListNo.indexOf(fruit);

    if (index >= 0) {
      this.productsListNo.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.productsListNo.push(event.option.viewValue);
    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();

  //   return this.allProductNo.filter(fruit => fruit.toLowerCase().includes(filterValue));
  // }

  clearCardsNo() {
    this.productsListNo = [];
  }

  addCardsToList() {

    this.applyBatchCostPriceToNewCards();

    let cards = (<FormArray>this.ProductForm.get('productCards'));
    cards.removeAt(cards.length - 1);

    var d = new Date();
    var year = d.getFullYear() + 1;
    var month = d.getMonth();
    var day = d.getDate();

    let cardExpDate = month + "/" + day + "/" + year;
    var date = new Date(year, month, day);

    for (let i = 0; i < this.productsListNo.length; i++) {

      (<FormArray>this.ProductForm.get('productCards')).push(
        this.createProductCardFormGroup({
          cardNumber: this.productsListNo[i],
          serialNumber: '',
          expiryDate: date
        }));

    }

    this.productsListNo = [];

  }

  addUmniahCardsToList() {

    let cards = (<FormArray>this.ProductForm.get('productCards'));
    cards.removeAt(cards.length - 1);

    var data = this.ProductForm.get("cardNumbersUmniah")?.value.trim().split(',');
    for (var i = 0; i < data.length; i++) {

      var _CardNo = "";
      var _Serial = "";

      var d = new Date();
      var year = d.getFullYear() + 1;
      var month = d.getMonth();
      var day = d.getDate();

      let cardExpDate = month + "/" + day + "/" + year;
      var _expDate = new Date(year, month, day);

      if (data[i] != null && data[i] != "") {
        _Serial = data[i].split('Serial No:')[1].split(']')[0];
        _CardNo = data[i].split('#:')[1].split(']')[0];
      }

      (<FormArray>this.ProductForm.get('productCards')).push(
        this.createProductCardFormGroup({
          cardNumber: _CardNo,
          serialNumber: _Serial,
          expiryDate: _expDate
        }));

    }
  }

  addZainCardsToList() {
    let cards = (<FormArray>this.ProductForm.get('productCards'));
    cards.removeAt(cards.length - 1);

    var data = this.ProductForm.get("cardNumbersUmniah")?.value.replace(/\n/g, " ");

    var _data = data.split('Serial: ').join(" ").split('   ').join("_");

    var result = _data.split("  ");

    for (var i = 0; i < result.length; i++) {

      var _CardNo = "";
      var _Serial = "";

      var d = new Date();
      var year = d.getFullYear() + 1;
      var month = d.getMonth();
      var day = d.getDate();

      let cardExpDate = month + "/" + day + "/" + year;
      var _expDate = new Date(year, month, day);

      if (result[i] != null && result[i] != "") {
        _Serial = result[i].split('_')[1];
        _CardNo = result[i].split('_')[0];
      }

      (<FormArray>this.ProductForm.get('productCards')).push(
        this.createProductCardFormGroup({
          cardNumber: _CardNo,
          serialNumber: _Serial,
          expiryDate: _expDate
        }));

    }

  }



  // addAllCardsToList() {
  //   let cards = (<FormArray>this.ProductForm.get('productCards'));
  //   cards.removeAt(cards.length - 1);

  //   var data = this.ProductForm.get("cardNumbersUmniah")?.value.replace(/\n/g, " ");

  //   if (data.includes('Product:')) {
  //     data = data.split('Product:')[1]
  //   }
  //   // var _data = data.split('Serial:').join(" ").split('   ').join(" ");

  //   //var result = _data.split("  ").join(" ");


  //   // var data2 = data.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "");
  //   //var data3 = data2.replace(data1, "")

  //   var d = new Date();
  //   var year = d.getFullYear() + 1;
  //   var month = d.getMonth();
  //   var day = d.getDate();

  //   let cardExpDate = month + "/" + day + "/" + year;
  //   var _expDate = new Date(year, month, day);

  //   const getRange = (str: any) => {
  //     const [_, intro, start, end] = str.match(/(\d{6})(\d{4})(\d{4})/)
  //     return Array.from(
  //       { length: end - start + 1 },
  //       (__, i) => intro + String(+start + i)         // .padStart(4, '0')
  //     )
  //   }

  //   const getCodes = (str: string) =>
  //     str.split(/[,\s]+/)                    // break on commas and/or spaces
  //       .map(str => str.replace(/\D/g, '')) // remove non-digits
  //       .filter(Boolean)                      // remove empties
  //       .filter(str => str.length == 14) // || str.length == 14
  //   //.flatMap(str => str.length == 14 ? getRange(str) : [str])

  //   const getSerial = (str: string) =>
  //     str.split(/[,\s]+/)                    // break on commas and/or spaces
  //       .map(str => str.replace(/\D/g, '')) // remove non-digits
  //       .filter(Boolean)                      // remove empties
  //       .filter(str => (str.length >= 9 && str.length < 14) || str.length == 16)

  //   var codes = getCodes(data.replaceAll("T00:00:00", "").replaceAll("96277-", "1111111").replaceAll("T", "00"));
  //   var serials = getSerial(data.replaceAll("T00:00:00", "").replaceAll("96277-", "1111111").replaceAll("T", "00"));

  //   // var _data1 = phoneNumbers(data);

  //   // let codes = [];
  //   // let serials = [];
  //   // for (let i = 0; i < _data1.length; i += 3) {
  //   //   codes.push(_data1[i])
  //   // }

  //   // for (let i = 1; i < _data1.length; i += 3) {
  //   //   serials.push(_data1[i])
  //   // }
  //   for (let i = 0; i < codes.length; i++) {

  //     (<FormArray>this.ProductForm.get('productCards')).push(
  //       new FormGroup({
  //         id: new FormControl(''),
  //         cardNumber: new FormControl(codes[i]),
  //         serialNumber: new FormControl(serials[i].replace("1111111", "")),
  //         expiryDate: new FormControl(_expDate),
  //         status: new FormControl(0),
  //         addedBy: new FormControl(this.localStorage.retrieve("userInfo").userId)
  //       }));

  //   }
  //   // console.log(codes)
  //   // console.log(serials)
  // }

  addAllCardsToList() {

    this.applyBatchCostPriceToNewCards();

    console.log('addAllCardsToList')
    let cards = (<FormArray>this.ProductForm.get('productCards'));
    cards.removeAt(cards.length - 1);

    var data = this.ProductForm.get("cardNumbers")?.value.replace(/\n/g, " ");


    var d = new Date();
    var year = d.getFullYear() + 1;
    var month = d.getMonth();
    var day = d.getDate();

    const numberRegexCode = /\b\d{14}\b/g;
    const codes = data.replaceAll("96277-", "").replaceAll("-", "").match(numberRegexCode);

    var serials: any;

    var _categoryName = this.product.subCategory.category.englishName;

    if (_categoryName.toLowerCase().includes("orange") || _categoryName.toLowerCase().includes("weinak")) {
      const numberRegexSerialOrang = /\b\d{9}\b/g;
      serials = data.replaceAll("96277-", "").replaceAll("-", "").match(numberRegexSerialOrang);
    }

    if (_categoryName.toLowerCase().includes("zain")) {
      const numberRegexSerialZain = /\b\d{12}\b/g;
      serials = data.replaceAll("-", "").match(numberRegexSerialZain);
    }

    if (_categoryName.toLowerCase().includes("umniah")) {
      const numberRegexSerialUmniah = /\b\d{11}\b/g;
      serials = data.replaceAll("-", "").match(numberRegexSerialUmniah);
    }

    var d = new Date();
    var year = d.getFullYear() + 1;
    var month = d.getMonth();
    var day = d.getDate();

    var _expDate = new Date(year, month, day);

    for (let i = 0; i < codes.length; i++) {

      (<FormArray>this.ProductForm.get('productCards')).push(
        this.createProductCardFormGroup({
          cardNumber: codes[i],
          serialNumber: serials[i] != undefined ? serials[i] : "",
          expiryDate: _expDate
        }));

    }

    this.ProductForm.get("cardNumbers")?.reset();

  }

  checkDublicateCodes() {
    this.spinnerOverlay = true;
    let productCard = this.ProductForm.value.productCards;
    var cardlst = []

    for (let i = 0; i < productCard.length; i++) {
      if (productCard[i].cardNumber != "" && productCard[i].cardNumber != null) {
        cardlst.push(productCard[i].cardNumber)
      }
    }
    var obj = {
      productId: this.product.id,
      cardsCode: cardlst
    }
    this.service.checkDublicateCode(obj).subscribe(data => {
      this.openSnackBar(data.message, 'snackBarSuccess');
      this.spinnerOverlay = false;
    }, error => {
      if (error.error.message != undefined) {
        this.openSnackBar(error.error.message, 'snackBarError');
      }
      else {
        this.openSnackBar(error.message, 'snackBarError');
      }
      this.spinnerOverlay = false;
    })

  }

  checkDublicateSerial() {
    this.spinnerOverlay = true;
    let productCard = this.ProductForm.value.productCards;
    var serialslst = []

    for (let i = 0; i < productCard.length; i++) {
      if (productCard[i].serialNumber != "" && productCard[i].serialNumber != null) {
        serialslst.push(productCard[i].serialNumber)
      }
    }
    var obj = {
      productId: this.product.id,
      serials: serialslst
    }
    this.service.checkDublicateSerial(obj).subscribe(data => {
      this.openSnackBar(data.message, 'snackBarSuccess');
      this.spinnerOverlay = false;
    }, error => {
      if (error.error.message != undefined) {
        this.openSnackBar(error.error.message, 'snackBarError');
      }
      else {
        this.openSnackBar(error.message, 'snackBarError');
      }
      this.spinnerOverlay = false;
    })

  }


  updateProductLockFlag() {
    this.spinnerOverlay = true;
    var obj = {
      "productId": this.product.id,
      "productLock": this.product.productLock
    }

    this.service.UpdateProductLock(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  updateProductLockFlagChange(event: MatSlideToggleChange) {
    // this.showAndroidUpdate = event.checked
    this.product.productLock = event.checked ? 1 : 0;
    this.updateProductLockFlag();
  }

  private extractByDigits(input: string, digits: number): string[] {
    if (!digits || digits < 1) return [];

    // حوّل أي شيء غير رقم إلى مسافة حتى نضمن حدود واضحة للأرقام
    const normalized = (input ?? '').replace(/\D+/g, ' ');

    const result = normalized.split(' ').map(part => {
      if (part.startsWith('96277')) {
        return part.substring(5); // Removes the first 5 characters ('96277')
      }
      return part;
    }).join(' ');

    // Regex آمن بدون lookbehind: يلتقط الرقم ضمن مجموعة
    // (^|\s)(\d{N})(?=\s|$)
    const re = new RegExp(`(^|\\s)(\\d{${digits}})(?=\\s|$)`, 'g');

    const out: string[] = [];
    let m: RegExpExecArray | null;

    while ((m = re.exec(result)) !== null) {
      out.push(m[2]);
    }

    return out;
  }

  addAllCardsToListWithCount() {

    this.applyBatchCostPriceToNewCards();

    const cards = this.ProductForm.get('productCards') as FormArray;


    if (cards?.length > 0) {
      cards.removeAt(cards.length - 1);
    }

    const rawText = (this.ProductForm.get('cardNumbers')?.value ?? '').toString();

    const pinDigits = Number(this.ProductForm.get('pinDigits')?.value);
    const serialDigits = Number(this.ProductForm.get('serialDigits')?.value);

    // استخراج PIN و Serial حسب الخانات المطلوبة
    const pins = this.extractByDigits(rawText.replaceAll("-", ""), pinDigits);
    const serials = this.extractByDigits(rawText.replaceAll("-", ""), serialDigits);

    // Expiry: مثل كودك (سنة لقدام)
    const d = new Date();
    const expDate = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());

    // أنشئ السطور بناءً على عدد الـPINs (أو استخدم Math.max إذا بدك)
    for (let i = 0; i < pins.length; i++) {
      cards.push(
        this.createProductCardFormGroup({
          cardNumber: pins[i],
          serialNumber: serials[i] ?? '',
          expiryDate: expDate
        })
      );
    }

    this.ProductForm.get('cardNumbers')?.reset();
  }


  activeDisactivePinSerialCount(event: MatSlideToggleChange) {
    this.ProductForm.get("serialPinCount")!.setValue(event.checked)
    if (!event.checked) {
      this.ProductForm.get("pinDigits")?.disable()
      this.ProductForm.get("serialDigits")?.disable()
    }
    else {
      this.ProductForm.get("pinDigits")?.enable()
      this.ProductForm.get("serialDigits")?.enable()
    }
  }

  fillcardNumbersList() {
    var _serialPinCount = this.ProductForm.get("serialPinCount")
    console.log(_serialPinCount?.value)
    if (_serialPinCount?.value) {
      this.addAllCardsToListWithCount()
    }
    else {
      this.addAllCardsToList()
    }
  }



}


